<template>

  <v-content>
      <v-container>
        <v-card
          flat
          outlined
          color="transparent"
        >
          <v-card-title>History</v-card-title>
          <v-divider />
          <v-card-text>
            In 2004, BLI Tool and Die Inc. was founded by the Ley and
            Bauer families in Fowler, Illinois. The Ley family
            operates the business and has provided three generations
            of dedicated machinists. Since BLI's inception, the central
            focus has been on providing customers with the best quality
            achieved through a combined century of experience. We
            believe this is the largest reason for our high customer
            satisfaction and retention rate. Moving forward, we look
            to attract and retain more customers and provide these
            customers with hassle free machining services.
          </v-card-text>

          <v-spacer></v-spacer>
          <v-img
              :src="require('../assets/history.jpg')"
              width="50%"
              height="auto"
              style="margin-left:25%;"
          ></v-img>
        </v-card>
      </v-container>
  </v-content>
</template>

<script>


export default {
  name: 'history',
  components: {

  },
  props: [

  ]
}
</script>

<style scoped>

</style>


<style src="../index.css"></style>